/**
 * Resolve the HTML id used for in-page jump links (KL-1058).
 * Prefer Contentful Jump Link (pretty hash) when set; otherwise entry id.
 *
 * @param {object} [entry] - Contentful entry (component data)
 * @returns {string|undefined}
 */
export const resolveJumpAnchorId = (entry) => {
  const pretty = entry?.jumpLink;
  if (typeof pretty === 'string') {
    const trimmed = pretty.trim();
    if (trimmed) {
      return trimmed;
    }
  }

  return entry?.sys?.id;
};

/**
 * Resolve the CSS scroll margin for an in-page jump target (KL-1058).
 *
 * @param {object} [entry] - Contentful entry (component data)
 * @returns {string|undefined}
 */
export const resolveJumpLinkMarginTop = (entry) => {
  const marginTop = entry?.jumpLinkMarginTop;

  return Number.isInteger(marginTop) && marginTop >= 0 ? `${marginTop}px` : undefined;
};
